'use client';

import { useAtomValue } from '@effect/atom-react';
import { Match } from 'effect';

import { GlossaryAlphabetList } from './GlossaryAlphabetList';
import { GlossaryFavoritesView } from './GlossaryFavoritesView';
import { GlossarySearchView } from './GlossarySearchView';

import {
  currentAlphabetFilterAtom,
  currentNameFilterAtom,
  glossaryModeAtom,
} from '../../../../effect/atom/glossary/glossaryFilters';
import { GlossaryMode } from '../../../../effect/data/glossary/glossaryMode';

export function GlossaryView() {
  const mode = useAtomValue(glossaryModeAtom);
  const alphabetFilter = useAtomValue(currentAlphabetFilterAtom);
  const nameFilter = useAtomValue(currentNameFilterAtom);

  return Match.value({ mode, alphabetFilter, nameFilter }).pipe(
    Match.when({ mode: GlossaryMode.alphabet, alphabetFilter: Match.string }, (selected) => (
      <GlossaryAlphabetList alphabetFilter={selected.alphabetFilter} />
    )),
    Match.when({ mode: GlossaryMode.search, nameFilter: Match.string }, (selected) => (
      <GlossarySearchView nameFilter={selected.nameFilter} />
    )),
    Match.orElse(() => <GlossaryFavoritesView />)
  );
}
